module.exports = __webpack_public_path__ + "img/team-list1.a14eb03b.png";